import { type ReactNode } from 'react';

import { Box } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';

import PushScreen from '@/designs-dev/device/PushScreen';
import FactList from '@/karehero-app/tell-us-once/intake/FactList';
import { RECHECK, RECHECK_ANSWERS } from '@/karehero-app/care/Recheck.content';

/**
 * CONCEPT. The benefits check, come back to: what they told it, as answers
 * that each change in a drawer, then Check again under them. A list rather
 * than the conversation reopened, because finding one answer is scanning, not
 * scrolling back through a chat.
 */
const RecheckAnswers = ({
  title,
  bar,
  onClose,
  onCheck,
  initialEditing,
}: {
  /** The form they filled in, by name, as the page's title. */
  title: string;
  /** The pushed page's bar, drawn by the hub so it matches its other pages. */
  bar: (title: string, close: () => void) => ReactNode;
  onClose: () => void;
  /** Check again: the page closes and Money shows what it found. */
  onCheck: () => void;
  /** Harness-only: open with this answer's drawer up. */
  initialEditing?: string;
}) => (
  <PushScreen onClose={onClose} bar={(close) => bar(title, close)}>
    {(close) => (
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', p: 2, pb: 4 }}>
        <FactList groups={RECHECK_ANSWERS} initialEditing={initialEditing} />
        <Box sx={{ pt: 3 }}>
          <Button
            variant='primary'
            size='lg'
            isFullWidth
            ariaLabel={RECHECK.check}
            onPress={() => {
              onCheck();
              close();
            }}
          >
            {RECHECK.check}
          </Button>
        </Box>
      </Box>
    )}
  </PushScreen>
);

export default RecheckAnswers;
